import * as React from 'react';

function SvgCreateTeam(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={136.357} height={58.694} {...props}>
      <g data-name="Group 2581" fill="#008afd">
        <path
          data-name="Path 5513"
          d="M68.249 21.371c-37.474 0-66.827 7.994-66.827 18.2s29.353 18.2 66.827 18.2c-29.836 0-53.208-7.2-53.208-16.389s23.372-16.39 53.208-16.39 53.208 7.2 53.208 16.39-23.372 16.389-53.208 16.389c37.473 0 66.827-7.993 66.827-18.2s-29.354-18.2-66.827-18.2z"
          opacity={0.36}
        />
        <path
          data-name="Path 5509"
          d="M68.567 58.694c-38.014 0-67.791-8.4-67.791-19.13s29.777-19.131 67.791-19.131 67.791 8.4 67.791 19.131-29.777 19.13-67.791 19.13zm0-36.964c-36.044 0-66.495 8.167-66.495 17.835s30.451 17.833 66.495 17.833 66.495-8.167 66.495-17.833-30.451-17.836-66.495-17.836z"
        />
      </g>
      <g data-name="Group 955" fill="none" stroke="#008afd">
        <g data-name="Group 950">
          <path data-name="Path 4153" d="M12.384 18.612L.5 25.472V14.725l11.884-6.859z" />
          <path data-name="Path 4154" d="M6.667 32.378l-.451.261V20.314l.451-.26z" />
        </g>
        <g data-name="Group 951">
          <path
            data-name="Path 4155"
            d="M2.416 15.454a1.128 1.128 0 01-.471.9c-.259.149-.471-.01-.471-.356a1.132 1.132 0 01.471-.9c.262-.154.471.006.471.356z"
          />
          <path
            data-name="Path 4156"
            d="M4.257 14.388a1.123 1.123 0 01-.471.9c-.26.151-.471-.009-.471-.355a1.13 1.13 0 01.471-.9c.259-.149.471.009.471.355z"
          />
          <path
            data-name="Path 4157"
            d="M6.095 13.326a1.128 1.128 0 01-.47.9c-.26.151-.471-.01-.471-.355a1.127 1.127 0 01.471-.9c.26-.15.471.008.47.355z"
          />
          <path
            data-name="Path 4158"
            d="M7.935 12.265a1.121 1.121 0 01-.471.9c-.26.151-.471-.009-.471-.355a1.129 1.129 0 01.471-.9c.261-.151.471.014.471.355z"
          />
          <path
            data-name="Path 4159"
            d="M9.774 11.202a1.13 1.13 0 01-.471.9c-.259.15-.471-.01-.471-.357a1.131 1.131 0 01.471-.9c.26-.148.471.012.471.357z"
          />
          <path
            data-name="Path 4160"
            d="M11.613 10.142a1.13 1.13 0 01-.471.9c-.26.151-.471-.01-.471-.356a1.128 1.128 0 01.471-.9c.26-.149.471.009.471.356z"
          />
        </g>
        <g data-name="Group 952">
          <path
            data-name="Path 4161"
            d="M2.416 17.766a1.127 1.127 0 01-.471.9c-.259.151-.471-.01-.471-.355a1.129 1.129 0 01.471-.9c.262-.15.471.008.471.355z"
          />
          <path
            data-name="Path 4162"
            d="M4.257 16.704a1.128 1.128 0 01-.471.9c-.26.149-.471-.01-.471-.356a1.126 1.126 0 01.471-.9c.259-.15.471.009.471.356z"
          />
          <path
            data-name="Path 4163"
            d="M6.095 15.642a1.128 1.128 0 01-.47.9c-.26.149-.471-.01-.471-.356a1.131 1.131 0 01.471-.9c.26-.149.471.01.47.356z"
          />
          <path
            data-name="Path 4164"
            d="M7.935 14.582a1.125 1.125 0 01-.471.9c-.26.149-.471-.01-.471-.356a1.127 1.127 0 01.471-.9c.261-.151.471.008.471.356z"
          />
          <path
            data-name="Path 4165"
            d="M9.774 13.52a1.13 1.13 0 01-.471.9c-.259.149-.471-.01-.471-.356a1.131 1.131 0 01.471-.9c.26-.152.471.009.471.356z"
          />
          <path
            data-name="Path 4166"
            d="M11.613 12.457a1.128 1.128 0 01-.471.9c-.26.15-.471-.01-.471-.356a1.124 1.124 0 01.471-.9c.26-.15.471.009.471.356z"
          />
        </g>
        <g data-name="Group 953">
          <path
            data-name="Path 4167"
            d="M2.416 20.003a1.126 1.126 0 01-.471.9c-.259.15-.471-.01-.471-.355a1.128 1.128 0 01.471-.9c.262-.149.471.009.471.355z"
          />
          <path
            data-name="Path 4168"
            d="M4.257 18.939a1.124 1.124 0 01-.471.9c-.26.15-.471-.009-.471-.356a1.131 1.131 0 01.471-.9c.259-.144.472.013.471.356z"
          />
          <path
            data-name="Path 4169"
            d="M6.095 17.881a1.125 1.125 0 01-.47.9c-.26.151-.471-.01-.471-.356a1.127 1.127 0 01.471-.9c.26-.15.471.01.47.356z"
          />
          <path
            data-name="Path 4170"
            d="M7.935 16.82a1.126 1.126 0 01-.471.9c-.26.149-.471-.01-.471-.357a1.127 1.127 0 01.471-.9c.261-.149.471.01.471.357z"
          />
          <path
            data-name="Path 4171"
            d="M9.774 15.759a1.13 1.13 0 01-.471.9c-.259.15-.471-.01-.471-.356a1.128 1.128 0 01.471-.9c.259-.151.471.006.471.356z"
          />
          <path
            data-name="Path 4172"
            d="M11.613 14.696a1.126 1.126 0 01-.471.9c-.26.149-.471-.01-.471-.356a1.127 1.127 0 01.47-.9c.261-.15.472.01.472.356z"
          />
        </g>
        <g data-name="Group 954">
          <path
            data-name="Path 4173"
            d="M2.416 22.513a1.124 1.124 0 01-.471.9c-.26.151-.47-.01-.47-.356a1.125 1.125 0 01.47-.9c.262-.151.471.007.471.356z"
          />
          <path
            data-name="Path 4174"
            d="M4.257 21.449a1.124 1.124 0 01-.471.9c-.26.151-.471-.009-.471-.356a1.128 1.128 0 01.471-.9c.259-.149.472.01.471.356z"
          />
          <path
            data-name="Path 4175"
            d="M6.096 20.387a1.126 1.126 0 01-.471.9c-.26.151-.471-.009-.471-.356a1.127 1.127 0 01.471-.9c.26-.149.471.01.471.356z"
          />
          <path
            data-name="Path 4176"
            d="M7.935 19.326a1.129 1.129 0 01-.471.9c-.26.15-.471-.01-.471-.356a1.127 1.127 0 01.471-.9c.261-.149.471.013.471.356z"
          />
          <path
            data-name="Path 4177"
            d="M9.774 18.264a1.129 1.129 0 01-.471.9c-.26.15-.471-.01-.471-.355a1.127 1.127 0 01.471-.9c.259-.15.471.008.471.355z"
          />
          <path
            data-name="Path 4178"
            d="M11.613 17.202a1.127 1.127 0 01-.471.9c-.259.149-.47-.009-.47-.356a1.127 1.127 0 01.47-.9c.26-.15.471.01.471.356z"
          />
        </g>
      </g>
      <g data-name="Group 2582" fill="none" stroke="#008afd">
        <g data-name="Group 950">
          <path data-name="Path 4153" d="M105.5 11.612l11.884 6.86V7.725L105.5.866z" />
          <path data-name="Path 4154" d="M111.218 25.378l.451.261V13.314l-.451-.26z" />
        </g>
        <g data-name="Group 951">
          <path
            data-name="Path 4155"
            d="M115.466 8.454a1.128 1.128 0 00.471.9c.259.149.471-.01.471-.356a1.132 1.132 0 00-.471-.9c-.26-.154-.471.006-.471.356z"
          />
          <path
            data-name="Path 4156"
            d="M113.627 7.388a1.123 1.123 0 00.471.9c.26.151.471-.009.471-.355a1.13 1.13 0 00-.471-.9c-.26-.149-.471.009-.471.355z"
          />
          <path
            data-name="Path 4157"
            d="M111.789 6.326a1.128 1.128 0 00.47.9c.26.151.471-.01.471-.355a1.127 1.127 0 00-.471-.9c-.26-.15-.471.008-.47.355z"
          />
          <path
            data-name="Path 4158"
            d="M109.949 5.265a1.121 1.121 0 00.471.9c.26.151.471-.009.471-.355a1.129 1.129 0 00-.471-.9c-.262-.151-.471.014-.471.355z"
          />
          <path
            data-name="Path 4159"
            d="M108.109 4.202a1.13 1.13 0 00.471.9c.259.15.471-.01.471-.357a1.131 1.131 0 00-.471-.9c-.259-.148-.471.012-.471.357z"
          />
          <path
            data-name="Path 4160"
            d="M106.271 3.142a1.13 1.13 0 00.471.9c.26.151.471-.01.471-.356a1.128 1.128 0 00-.471-.9c-.26-.149-.471.009-.471.356z"
          />
        </g>
        <g data-name="Group 952">
          <path
            data-name="Path 4161"
            d="M115.466 10.766a1.127 1.127 0 00.471.9c.259.151.471-.01.471-.355a1.129 1.129 0 00-.471-.9c-.26-.15-.471.008-.471.355z"
          />
          <path
            data-name="Path 4162"
            d="M113.627 9.704a1.128 1.128 0 00.471.9c.26.149.471-.01.471-.356a1.126 1.126 0 00-.471-.9c-.26-.15-.471.009-.471.356z"
          />
          <path
            data-name="Path 4163"
            d="M111.789 8.642a1.128 1.128 0 00.47.9c.26.149.471-.01.471-.356a1.131 1.131 0 00-.471-.9c-.26-.149-.471.01-.47.356z"
          />
          <path
            data-name="Path 4164"
            d="M109.949 7.582a1.125 1.125 0 00.471.9c.26.149.471-.01.471-.356a1.127 1.127 0 00-.471-.9c-.262-.151-.471.008-.471.356z"
          />
          <path
            data-name="Path 4165"
            d="M108.109 6.52a1.13 1.13 0 00.471.9c.259.149.471-.01.471-.356a1.131 1.131 0 00-.471-.9c-.259-.152-.471.009-.471.356z"
          />
          <path
            data-name="Path 4166"
            d="M106.271 5.457a1.128 1.128 0 00.471.9c.26.15.471-.01.471-.356a1.124 1.124 0 00-.471-.9c-.26-.15-.471.009-.471.356z"
          />
        </g>
        <g data-name="Group 953">
          <path
            data-name="Path 4167"
            d="M115.466 13.004a1.126 1.126 0 00.471.9c.259.15.471-.01.471-.355a1.128 1.128 0 00-.471-.9c-.26-.149-.471.009-.471.355z"
          />
          <path
            data-name="Path 4168"
            d="M113.627 11.939a1.124 1.124 0 00.471.9c.26.15.471-.009.471-.356a1.131 1.131 0 00-.471-.9c-.26-.144-.472.013-.471.356z"
          />
          <path
            data-name="Path 4169"
            d="M111.789 10.881a1.125 1.125 0 00.47.9c.26.151.471-.01.471-.356a1.127 1.127 0 00-.471-.9c-.26-.15-.471.01-.47.356z"
          />
          <path
            data-name="Path 4170"
            d="M109.949 9.82a1.126 1.126 0 00.471.9c.26.149.471-.01.471-.357a1.127 1.127 0 00-.471-.9c-.262-.149-.471.01-.471.357z"
          />
          <path
            data-name="Path 4171"
            d="M108.109 8.759a1.13 1.13 0 00.471.9c.259.15.471-.01.471-.356a1.128 1.128 0 00-.471-.9c-.258-.151-.471.006-.471.356z"
          />
          <path
            data-name="Path 4172"
            d="M106.271 7.696a1.126 1.126 0 00.471.9c.26.149.471-.01.471-.356a1.127 1.127 0 00-.47-.9c-.261-.15-.472.01-.472.356z"
          />
        </g>
        <g data-name="Group 954">
          <path
            data-name="Path 4173"
            d="M115.466 15.513a1.124 1.124 0 00.471.9c.26.151.47-.01.47-.356a1.125 1.125 0 00-.47-.9c-.26-.151-.471.007-.471.356z"
          />
          <path
            data-name="Path 4174"
            d="M113.627 14.449a1.124 1.124 0 00.471.9c.26.151.471-.009.471-.356a1.128 1.128 0 00-.471-.9c-.26-.149-.472.01-.471.356z"
          />
          <path
            data-name="Path 4175"
            d="M111.788 13.387a1.126 1.126 0 00.471.9c.26.151.471-.009.471-.356a1.127 1.127 0 00-.471-.9c-.26-.149-.471.01-.471.356z"
          />
          <path
            data-name="Path 4176"
            d="M109.949 12.326a1.129 1.129 0 00.471.9c.26.15.471-.01.471-.356a1.127 1.127 0 00-.471-.9c-.262-.149-.471.013-.471.356z"
          />
          <path
            data-name="Path 4177"
            d="M108.109 11.264a1.129 1.129 0 00.471.9c.26.15.471-.01.471-.355a1.127 1.127 0 00-.471-.9c-.258-.15-.471.008-.471.355z"
          />
          <path
            data-name="Path 4178"
            d="M106.271 10.202a1.127 1.127 0 00.471.9c.259.149.47-.009.47-.356a1.127 1.127 0 00-.47-.9c-.26-.15-.471.01-.471.356z"
          />
        </g>
      </g>
      <path
        data-name="Path 5517"
        d="M89.015 34.429l-6.311-3.5-6.311 3.5a3.657 3.657 0 00-1.876 3.241v5.032h16.46V37.67a3.737 3.737 0 00-1.962-3.241z"
        fill="#008afd"
      />
      <path
        data-name="Path 5518"
        d="M90.976 43.639H74.519a.806.806 0 01-.853-.853v-5.032a4.528 4.528 0 012.388-4.008l6.311-3.5a.775.775 0 01.853 0l6.311 3.5a4.528 4.528 0 012.388 4.008v5.032a1.085 1.085 0 01-.941.853zm-15.607-1.706h14.75v-4.179a2.834 2.834 0 00-1.45-2.473l-5.885-3.241-5.885 3.241a2.765 2.765 0 00-1.45 2.473v4.179z"
        fill="#182152"
      />
      <path
        data-name="Path 5519"
        d="M90.976 38.522v-.853a3.728 3.728 0 00-1.876-3.241l-6.311-3.5-6.311 3.5a3.657 3.657 0 00-1.876 3.241v.853"
        fill="#fff"
      />
      <path
        data-name="Path 5520"
        d="M90.976 39.375a.806.806 0 01-.853-.853v-.853a2.834 2.834 0 00-1.45-2.473l-5.885-3.241-5.885 3.241a2.765 2.765 0 00-1.45 2.473v.853a.853.853 0 11-1.706 0v-.853a4.528 4.528 0 012.388-4.008l6.311-3.5a.775.775 0 01.853 0l6.311 3.5a4.528 4.528 0 012.388 4.008v.853a1.161 1.161 0 01-1.022.853z"
        fill="#182152"
      />
      <path
        data-name="Path 5521"
        d="M86.882 27.265c0 2.814-1.876 5.97-4.179 5.97s-4.179-3.155-4.179-5.97a4.179 4.179 0 018.358 0z"
        fill="#fff"
      />
      <path
        data-name="Path 5522"
        d="M82.706 34.087c-2.9 0-5.032-3.582-5.032-6.823a5.032 5.032 0 0110.063 0c-.002 3.241-2.131 6.823-5.031 6.823zm0-10.149a3.091 3.091 0 00-3.326 3.326c0 2.559 1.62 5.117 3.326 5.117 1.62 0 3.326-2.559 3.326-5.117a3.05 3.05 0 00-3.326-3.325z"
        fill="#182152"
      />
      <path
        data-name="Path 5523"
        d="M52.684 34.429l-6.311-3.5-6.311 3.5a3.657 3.657 0 00-1.876 3.241v5.032h16.46V37.67a3.919 3.919 0 00-1.962-3.241z"
        fill="#008afd"
      />
      <path
        data-name="Path 5524"
        d="M54.56 43.639H38.101a.806.806 0 01-.853-.853v-5.032a4.528 4.528 0 012.388-4.008l6.311-3.5a.775.775 0 01.853 0l6.311 3.5a4.528 4.528 0 012.388 4.008v5.032a1 1 0 01-.939.853zm-15.606-1.706h14.754v-4.179a2.834 2.834 0 00-1.45-2.473l-5.885-3.241-5.885 3.241a2.765 2.765 0 00-1.45 2.473v4.179z"
        fill="#182152"
      />
      <path
        data-name="Path 5525"
        d="M54.56 38.522v-.853a3.728 3.728 0 00-1.876-3.241l-6.311-3.5-6.311 3.5a3.657 3.657 0 00-1.876 3.241v.853"
        fill="#fff"
      />
      <path
        data-name="Path 5526"
        d="M54.56 39.375a.806.806 0 01-.853-.853v-.853a2.834 2.834 0 00-1.45-2.473l-5.885-3.241-5.885 3.241a2.765 2.765 0 00-1.45 2.473v.853a.806.806 0 01-.853.853.806.806 0 01-.853-.853v-.853a4.528 4.528 0 012.39-4.006l6.311-3.5a.775.775 0 01.853 0l6.311 3.5a4.528 4.528 0 012.388 4.008v.853a1.081 1.081 0 01-1.024.851z"
        fill="#182152"
      />
      <path
        data-name="Path 5527"
        d="M50.467 27.265c0 2.814-1.876 5.97-4.179 5.97s-4.179-3.155-4.179-5.97a3.892 3.892 0 014.179-4.179 3.892 3.892 0 014.179 4.179z"
        fill="#fff"
      />
      <path
        data-name="Path 5528"
        d="M46.374 34.087c-2.9 0-5.032-3.582-5.032-6.823a4.745 4.745 0 015.032-5.032 4.79 4.79 0 015.032 5.032c-.086 3.241-2.218 6.823-5.032 6.823zm0-10.149a3.091 3.091 0 00-3.326 3.326c0 2.559 1.62 5.117 3.326 5.117s3.326-2.559 3.326-5.117a3.09 3.09 0 00-3.326-3.325z"
        fill="#182152"
      />
      <path
        data-name="Path 5529"
        d="M76.137 35.367v7.42h-22.6v-7.42a5.008 5.008 0 015.032-4.861 7.806 7.806 0 006.311 3.411 7.7 7.7 0 006.311-3.411 4.989 4.989 0 014.946 4.861z"
        fill="#ff9a14"
      />
      <path
        data-name="Path 5530"
        d="M76.137 43.639h-22.6a.806.806 0 01-.853-.853v-7.42a5.9 5.9 0 015.8-5.714.831.831 0 01.768.341 6.719 6.719 0 0011.172 0 .831.831 0 01.768-.341 5.9 5.9 0 015.8 5.714v7.42a.806.806 0 01-.855.853zM54.39 41.933h20.894v-6.567a4.2 4.2 0 00-3.752-4.008 8.483 8.483 0 01-6.652 3.326 8.36 8.36 0 01-6.652-3.326 4.134 4.134 0 00-3.752 4.008v6.567z"
        fill="#182152"
      />
      <g data-name="Group 2587" transform="translate(56.607 14.131)" fill="#fff">
        <path
          data-name="Path 5531"
          d="M0 25.585v-4.349a1.621 1.621 0 01.853-1.365 10.465 10.465 0 007.334 2.985 10.69 10.69 0 007.334-2.985 1.739 1.739 0 01.853 1.365v4.349z"
        />
        <ellipse
          data-name="Ellipse 464"
          cx={6.055}
          cy={7.59}
          rx={6.055}
          ry={7.59}
          transform="translate(2.217)"
        />
      </g>
      <path
        data-name="Path 5532"
        d="M64.88 30.164c-3.752 0-6.908-3.838-6.908-8.443s3.07-8.443 6.908-8.443 6.908 3.838 6.908 8.443-3.156 8.443-6.908 8.443zm0-15.18c-2.814 0-5.2 3.07-5.2 6.737 0 3.752 2.3 6.737 5.2 6.737s5.2-3.07 5.2-6.737c-.083-3.752-2.386-6.734-5.2-6.734z"
        fill="#182152"
      />
      <path
        data-name="Path 5533"
        d="M71.446 16.349c-.341-2.814-5.8-5.2-10.49-2.985a4.058 4.058 0 00-2.644 2.985s-1.876 1.194.682 6.482c0 0-.6-1.279 1.279-2.644 0 0-.853-2.473 1.535-2.473 0 0 1.962 1.023 3.155.768a7.42 7.42 0 003.156-.768c2.388 0 1.535 2.473 1.535 2.473 1.876 1.279 1.279 2.644 1.279 2.644 2.39-5.288.513-6.482.513-6.482z"
        fill="#e1e6e7"
      />
      <path
        data-name="Path 5534"
        d="M58.91 23.769a.819.819 0 01-.768-.512c-2.217-4.691-1.279-6.652-.682-7.334 1.194-5.543 13.475-5.629 14.754 0 .6.682 1.535 2.644-.682 7.334a.84.84 0 01-1.535-.682c0-.085.171-.768-.938-1.62a.932.932 0 01-.341-1.023 1.649 1.649 0 000-1.109c-.085-.171-.341-.171-.512-.256a7.363 7.363 0 01-3.326.768 7.09 7.09 0 01-3.326-.768.608.608 0 00-.512.256 1.65 1.65 0 000 1.109.851.851 0 01-.341 1.023c-1.024.681-1.024 1.364-1.024 1.534a.639.639 0 01.085.426.917.917 0 01-.852.854zm5.97-10.4c-2.217 0-5.458 1.109-5.714 3.07a.718.718 0 01-.341.6c-.256.171-.6 1.194.085 3.241.085-.171.256-.256.426-.426a3.076 3.076 0 01.341-2.055 2.4 2.4 0 012.132-.938.927.927 0 01.426.085 5.064 5.064 0 002.644.682h.341a6.031 6.031 0 002.644-.682.639.639 0 01.426-.085 2.518 2.518 0 012.132.938 3.008 3.008 0 01.341 2.047l.426.426c.6-2.047.256-3.07 0-3.241a.863.863 0 01-.341-.6c-.51-1.873-3.666-3.067-5.971-3.067z"
        fill="#182152"
      />
      <g data-name="Group 2589">
        <g data-name="Group 2588" fill="#008afd">
          <path
            data-name="Path 4223"
            d="M80.753 15.505a.852.852 0 01-.849-.849V7.013a.85.85 0 011.7 0v7.643a.852.852 0 01-.851.849z"
          />
          <path
            data-name="Path 4224"
            d="M84.574 11.683h-7.643a.85.85 0 010-1.7h7.643a.85.85 0 010 1.7z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgCreateTeam;
